<template>
    <span><template v-for="(part, index) in parts" :key="index"><mark v-if="part.isMatch" class="highlight">{{ part.text }}</mark><template v-else>{{ part.text }}</template></template></span>
</template>

<script setup>
import { computed } from 'vue';
import { splitByMatch } from './buildStructureTree';

const props = defineProps({
    text: { type: String, default: '' },
    query: { type: String, default: '' },
});

const parts = computed(() => splitByMatch(props.text, props.query));
</script>

<style scoped>
.highlight {
    padding: 0 1px;
    border-radius: 2px;
    background: #fef08a;
    color: inherit;
}
</style>
